import { useCallback } from 'react';

import { batch, useDispatch } from 'react-redux';

import { editLandingPageThunk } from 'store/itinerariesItem/thunks';
import { closeModalAction } from 'store/modal';

import { IUseUpdatePrimaryPhotoProps, IUseUpdatePrimaryPhotoCallbackParams } from './types';

// TODO: must be universal with other useUpdatePrimaryPhoto
function useUpdatePrimaryPhoto(props: IUseUpdatePrimaryPhotoProps) {
  const { pageIndex } = props;

  const dispatch = useDispatch();

  return useCallback(
    ({ asset, point = asset?.imageCoords }: IUseUpdatePrimaryPhotoCallbackParams) => {
      const newObject = {
        primaryImageId: asset?.id || null,
        primaryImageUrl: asset?.url || null,
        primaryImageManual: true,
        primaryImageCoords: point || null,
        primaryImageVersion400: asset?.version400 || null,
        primaryImageVersion800: asset?.version800 || null,
        primaryImageVersion1200: asset?.version1200 || null,
        primaryImageVersion1600: asset?.version1600 || null,
        primaryImageVersion2400: asset?.version2400 || null,
      };

      batch(() => {
        dispatch(editLandingPageThunk({ newObject, pageIndex }));
        dispatch(closeModalAction());
      });
    },
    [dispatch, pageIndex],
  );
}

export default useUpdatePrimaryPhoto;
